import { memo } from 'react'
import { MenuItem } from '@mui/material'
import { Select, TextField, Stack, Subheader3, Tooltip } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getSelectedTenant, getTenantsListForSharing } from '@tabeeb/modules/sessionsPage/selectors/contentSharings'
import { setTenantForSharing, updateUsersSearchValue } from '@tabeeb/modules/sessionsPage/actions'

interface DestinationTenantProps {
  contentSharingType: ContentSharingModelType
}

interface Tenant {
  Id: string
  Name: string
  IsPredefined?: boolean
}

const DestinationTenant: React.FC<DestinationTenantProps> = ({ contentSharingType }) => {
  const dispatch = useDispatch()
  const tenantsList = useSelector((state) => getTenantsListForSharing(state, { contentSharingType }))
  const selectedTenant = useSelector((state) => getSelectedTenant(state, { contentSharingType }))
  const usersSearchInputValue = useSelector((state) => state.sessionsPage.usersSearchInputValue)

  const _handleChange = (e) => {
    const tenantName = e.target.value
    const tenant = tenantsList.find((ten: Tenant) => ten.Name === tenantName)

    dispatch(setTenantForSharing(tenant))
    if (usersSearchInputValue) {
      dispatch(updateUsersSearchValue({ searchText: usersSearchInputValue, tenantId: tenant.Id }))
    }
  }

  return (
    <Stack>
      <Subheader3>Tenant Destination</Subheader3>
      {selectedTenant?.IsPredefined ? (
        <Tooltip text={selectedTenant.Name}>
          <TextField value={selectedTenant.Name} disabled />
        </Tooltip>
      ) : (
        <Select
          size='small'
          title={selectedTenant?.Name}
          displayEmpty
          value={selectedTenant?.Name || ''}
          onChange={_handleChange}
          fullWidth
        >
          {tenantsList &&
            tenantsList.map((tenant: Tenant) => (
              <MenuItem key={tenant.Id} value={tenant.Name}>
                {tenant.Name}
              </MenuItem>
            ))}
        </Select>
      )}
    </Stack>
  )
}

export default memo(DestinationTenant)

